/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Smtitle1Inputs */

const zh_landing_admin_smtitle1 = /** @type {(inputs: Landing_Admin_Smtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把任意内容变成智能学习材料`)
};

const en_landing_admin_smtitle1 = /** @type {(inputs: Landing_Admin_Smtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn Anything Into Smart Study Materials`)
};

const es_landing_admin_smtitle1 = /** @type {(inputs: Landing_Admin_Smtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte cualquier cosa en materiales de estudio inteligentes`)
};

/**
* | output |
* | --- |
* | "Turn Anything Into Smart Study Materials" |
*
* @param {Landing_Admin_Smtitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_smtitle1 = /** @type {((inputs?: Landing_Admin_Smtitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Smtitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_smtitle1(inputs)
	if (locale === "en") return en_landing_admin_smtitle1(inputs)
	return es_landing_admin_smtitle1(inputs)
});
export { landing_admin_smtitle1 as "landing_admin_smTitle" }